<script lang="ts">
  import { getContext, onMount, createEventDispatcher } from "svelte";
  import WrapField from "$components/form/Fields/WrapField.svelte";
  import OVIcon from "$components/+shared/OVIcon/OVIcon.svelte";
  import Dropdown from "$components/+design-system/Dropdown/Dropdown.svelte";
  import OptionGroup from "$components/+design-system/Dropdown/fields/OptionGroup.svelte";
  import Option from "$components/+design-system/Dropdown/fields/Option.svelte";
  import cx from "classnames";
  import { Selector } from "$components/+shared/OVIcon";
  import type { SelectOption } from "models/shared-types";
  import type { createFormStore } from "$components/form/store";

  export let name: string;
  export let label: string = "";
  export let validationRules: Record<string, any> = {};
  export let placeHolder: string | undefined = undefined;
  export let value: SelectOption | undefined = undefined;
  export let options: SelectOption[] = [];
  export let wrapperClassname = "";

  let ref: HTMLDivElement;

  const formStore: ReturnType<typeof createFormStore> | undefined = getContext("form");
  const dispatch = createEventDispatcher();

  function onSelect(event: Event) {
    value = (event as CustomEvent).detail;

    if (formStore) {
      formStore.setField(name, value?.value);
    } else if (value) {
      dispatch("change", value);
    }
  }

  onMount(() => {
    if (formStore) {
      value = options.find((o) => o.value === $formStore?.values[name] ?? undefined);
      formStore.addRef(name, ref);
    }
  });
</script>

<WrapField {label} {name} {wrapperClassname} {validationRules}>
  <div bind:this={ref}>
    <Dropdown fullWidth>
      <button
        let:active
        slot="trigger"
        type="button"
        class={cx(
          "flex min-h-[36px] w-full flex-nowrap items-center justify-between gap-2 rounded-lg border-[0.5px] border-black/10 p-2.5 text-sm transition-colors dark:border-white/10",
          "focus:ring-focused-blue focus-visible:outline-none focus-visible:ring",
          {
            "bg-black/2 hover:bg-black/3 dark:bg-white/3 dark:hover:bg-white/4": !active,
            "bg-black/3 dark:bg-white/4": active,
          }
        )}
      >
        {#if value}
          <span class="truncate text-neutral-600 dark:text-neutral-300">{value.name}</span>
        {:else}
          <span class="truncate text-neutral-400 dark:text-neutral-400">
            {placeHolder}
          </span>
        {/if}
        <OVIcon icon={Selector} class="text-neutral-400/80 dark:text-neutral-400" />
      </button>

      <OptionGroup bind:value on:select={onSelect}>
        {#each options as option}
          <Option
            title={option.name}
            value={option}
            description={option.description}
            key={(o) => o.value}
          />
        {/each}
      </OptionGroup>
    </Dropdown>
  </div>
</WrapField>
